if (window.location.href === "https://gatineau.com/pages/personalised-skincare-routine") {
    // Select the element by its class
    const pageTitle = document.querySelector('.page-title');
    // Remove the element if it exists
    if (pageTitle) {
        pageTitle.remove();
    }

	document.querySelector('.blog-post-detail').style.marginRight = '0px';
	document.querySelector('.blog-post-detail').style.marginLeft = '0px';
	document.querySelector('.blog-post-detail').style.width = '100%';
	document.querySelector('.blog-post-detail').style.maxWidth = 'unset';

	document.querySelector('.section-spacing').style.display = 'flex';

	document.querySelector('.section-spacing').querySelector('.row').style.marginLeft = '0px';
	document.querySelector('.section-spacing').querySelector('.row').style.marginRight = '0px';
	document.querySelector('.section-spacing').querySelector('.row').style.width = '100%';
	document.querySelector('.section-spacing').querySelector('.row').style.maxWidth = 'unset';

	document.querySelector('.section-spacing').querySelector('.columns').style.display = 'flex';
	document.querySelector('.section-spacing').querySelector('.columns').style.marginRight = '0px';
	document.querySelector('.section-spacing').querySelector('.columns').style.marginLeft = '0px';

}

window.addEventListener('message', function(e) {
	    var $iframe = document.getElementById('renude-analysis');
		if($iframe) {
			var $parent = $iframe.parentNode;
			$parent.style.margin = '0px';
			$parent.style.maxWidth = 'unset';
			// var $gparent = $parent.parentNode;
			// $gparent.style.margin = '0px';

			var eventName = e.data[0];
			var data = e.data[1];
			function createCartWithCustomAttributes(
			sessionId,
			businessId,
			productId,
			mentionedProductId = []
			) {
			// First, check if the cart already has items
			fetch(window.Shopify.routes.root + "cart.js")
				.then((response) => response.json())
				.then((cart) => {
				if (cart.items.length === 0) {
					// The cart is empty, create a cart with a zero-quantity product
					const cartData = {
					items: [
						{
						quantity: 0, // Zero quantity means no visible product
						id: productId, // A valid variant ID for a placeholder product
						properties: {
							session_id: sessionId,
							business_id: businessId,
							mentionedProductId: mentionedProductId,
						},
						},
					],
					};

					fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(cartData),
					})
					.then((response) => response.json())
					.then(() => {
						// Update the cart attributes once the cart is created
						updateCartAttributes(sessionId, businessId, mentionedProductId);
					})
					.catch((error) => {
						console.error("Error creating cart:", error);
					});
				} else {
					// The cart already has products, so just update the attributes
					updateCartAttributes(sessionId, businessId, mentionedProductId);
				}
				})
				.catch((error) => {
				console.error("Error checking cart:", error);
				});
			}

			// Function to update cart attributes (session_id, business_id)
			function updateCartAttributes(sessionId, businessId, mentionedProductId) {
			const updates = {
				attributes: {
				session_id: sessionId,
				business_id: businessId,
				mentionedProductId: mentionedProductId,
				},
			};

			fetch(window.Shopify.routes.root + "cart/update.js", {
				method: "POST",
				headers: {
				"Content-Type": "application/json",
				},
				body: JSON.stringify(updates),
			})
				.then((response) => response.json())
				.then((data) => {
				console.log("Cart attributes updated:", data);
				})
				.catch((error) => {
				console.error("Error updating cart attributes:", error);
				});
			}

			switch(eventName) {
				case 'setHeight':
					$iframe.height = data;
					break;
				case 'setTopByWindow':
				window.scrollTo({ top: data, behavior: 'smooth' });
				break;
				case 'setTopByIframe':
				$iframe.scrollIntoView({behavior: 'smooth', block: 'start'});
				break;
			case 'renude-setup-track':
				const payloadData = JSON.parse(data)
					createCartWithCustomAttributes(
					payloadData.session_id,
					payloadData.BID,
					payloadData.external_id,
					payloadData.mentionedProductId
					);
			case 'get-utm':
				const currentUrl = window.location.href;
				$iframe.contentWindow.postMessage(
				currentUrl,
				'*'
				);
				break;
				break;
			}
		}
	}, false);